<template lang="pug">
    el-card.box-processo(shadow="hover")
      el-row.caixa-pesquisa(:gutter="30")
        el-col(:span="12")
          div.pesquisa
            el-button.botao-voltar(
                  type="primary"
                  @click="voltar"
                  v-if="!processo"
                )
              span.center
                i.fas.fa-chevron-left
            h1.titulo {{ processo ? 'Processo encontrado' : 'Pesquisar Processo' }}
      el-row.caixa-pesquisa(:gutter="30")
        el-col(:span="12")
          h4 Número do Processo:
          div.pesquisa
            el-input(
              placeholder="N° do Processo",
              class="input-with-select",
              v-model="numProcesso"
            )
            el-button.botao-limpar(
              id='botao-limpar',
              @click="limpar"
            )
              span Limpar
            el-button.color-default(
              type="primary"
              icon="el-icon-search",
              id='botao-pesquisar',
              @click="pesquisar"
            )
              span Pesquisar
      el-row.caixa-pesquisa(:gutter="30")
        el-col(:span="24")
          card-mover-processo(
            :processo="processo"
            :opcoesAcoes="true",
          )
      el-row.caixa-pesquisa(:gutter="30")
        el-col(:span="24", v-if="processo")
          app-label(label="Selecione o setor que deseja mover o processo:", style="margin-top: 10px")
          h4 Setor:
          el-select.select(
            placeholder="Selecione a caixa",
            class="input-with-select",
            v-model="setor",
            class="select",
            :disabled="(aguardandoDistribuicao || !!conversaAberta)",
            filterable
          )
            el-option(
              v-for="setor in setoresFluxo",
              :key="setor.acao",
              :label="setor.nome",
              :value="setor.acao"
            )
      el-row.caixa-pesquisa(:gutter="30", v-if="processo")
        el-col(:span="24")
          div(class="botao-processo", v-if="processo && this.isMaranhao()")
            el-button.btn(
              type="primary",
              @click="openModalNotificacao()",
            )
              span.center
                i.fa.fa-file.icon
                b &nbsp Modelo
          h4(style="margin-top: 10px; margin-bottom:30px") Justificativa:
          app-editor-texto.input(
              @onTextChange="onTextChange",
              v-model="mensagem",
              ref="editorTexto"
              v-if="!conversaAberta"
            )
          template(v-if="this.isAmapa()", style="margin-top: 10px; margin-bottom:30px")
            app-anexo(
              :id="'upload-anexo-despacho'"
              @uploadFile="uploadFile",
              :files="dados.anexos",
              @removeFile="removeDocumento($event)",
              :showAnexar="verificaTamanho"
              :exibirDownload="false"
              :tipoExibir="'ANEXO_MANUTENCAO'"
            )
          div.botao-processo
            div
              el-button(
                type="primary"
                @click="moverProcesso"
                class="button-mover"
                :disabled="aguardandoDistribuicao"
              )
                span.center
                  b Mover &nbsp
                  i.fas.fa-chevron-right
        el-col(:span="12")
         app-modal-distribuicao(
            :processo="processo",
            :mensagem="mensagemFormatada",
            :tarefa="tarefa",
            :dados="dados"
            @closeModal="closeModal",
            @limparDados="limpar"
            v-if="openModal"
          )
        el-col(:span='12')
          app-modal-selecionar-modelo-notificacao(
            :tiposModelo="tiposModelo",
            titulo='Modelos de Justificativa',
            :idProcesso="processo.id"
            v-if="showModalNotificacao",
            :showModal="showModalNotificacao"
            @closeModal="fecharModalNotificacao",
            @setTextoJustificativa="setTextoJustificativa"
          )
</template>
<script>
import { parseString } from 'xml2js'
import axios from '@/utils/api'
import AppLabel from '@/components/AppLabel'
import {buscarProcesso, getXmlFluxo, moverProcesso, buscarTarefa} from '@/utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppOpcoesHeaderAnalise from '../analise/components/modal/AppOpcoesHeaderAnalise.vue'
import CardMoverProcesso from './components/CardMoverProcessos.vue'
import AppModalDistribuicao from './components/modal/AppModalDistribuicao.vue'
import AppModalSelecionarModeloNotificacao from '../../screens/analise/components/AppModalSelecionarModeloNotificacao.vue'
import AppAnexo from '@/components/AppAnexo'
import _ from 'lodash'
import { mapActions } from 'vuex'

export default {
  components: {
    AppLabel,
    AppEditorTexto,
    AppOpcoesHeaderAnalise,
    CardMoverProcesso,
    AppModalDistribuicao,
    AppModalSelecionarModeloNotificacao,
    AppAnexo
  },
  data () {
    return {
      numProcesso: '',
      mensagem: '',
      dados: {
        idProcesso: null,
        justificativa: '',
        anexos: []
      },
      processo: null,
      setor: null,
      setoresFluxo: null,
      tarefa: null,
      openModal: false,
      showModalNotificacao: false,
      tiposModelo: [7],
      conversaAberta: false
    }
  },
  mixins: [
    AppNotificacao
  ],
  computed: {
    mensagemFormatada () {
      return this.mensagem.replace(/<[\w\s="-:;]+>*|&nbsp;*|<\/\w+>/g, '').replace(/( ){2,}/g, '$1').trim()
    },
    verificaTamanho () {
      return this.dados.anexos.length <= 1
    },
    aguardandoDistribuicao () {
      return ((this.processo && (this.processo.status === 'AGUARDANDO_ANALISE_DISTRIBUICAO')) ||
              (this.processo && (this.processo.status === 'AGUARDANDO_DISTRIBUICAO')))
    }
  },
  methods: {
    ...mapActions({
      findDespachosByIdProcesso: 'despacho/findDespachosByIdProcesso',
      criarDespachoMovimentarProcesso: 'despacho/criarDespachoMovimentarProcesso',
      vereficaProcessoTemVtn: 'vtn/processoTemVtn'
    }),

    erroBuscaProcesso () {
      return this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
        'Erro ao buscar o Processo, verifique o N° do Processo')
    },

    async pesquisar () {
      this.tarefa = null
      let fezVtn = false
      if (!this.numProcesso || this.numProcesso === '') this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha o campo N° do Processo')
      else {
        const response = await buscarProcesso(this.numProcesso)
        if (!response) {
          return this.erroBuscaProcesso()
        }
        if (this.isAmapa()) {
          await this.vereficaProcessoTemVtn(this.numProcesso).then((r) => {
            fezVtn = r
          })
        }
        const taskResponse = await buscarTarefa(response.id)
        if (response && taskResponse) {
          const status = this.getConversaPerdidaPendente(response.id)
          if (
            status === true ||
            (response.statusConversaExterno && !['ENCERRADA', 'CANCELADA', 'FECHADA'].includes(response.statusConversaExterno.toUpperCase())) ||
            (response.statusConversaInterno && !['ENCERRADA', 'CANCELADA', 'FECHADA'].includes(response.statusConversaInterno.toUpperCase()))
          ) {
            this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Processo com pendência')
          } else if (this.isAmapa() && fezVtn) {
            this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Processo não pode ser movido pois já possui um cálculo de VTN')
          } else {
            this.processo = response
            if (this.aguardandoDistribuicao) {
              this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'O processo não foi distribuído corretamente. Por favor, utilize a caixa "Distribuir Processo".')
            }
            this.dados.idProcesso = response.id
            this.tarefa = {
              name: taskResponse.nameKeyCurrentTask,
              acoes: taskResponse.nextDecisions.map(d =>
                ({nome: d.label ? d.label : d.codigo, valor: d.codigo}))}
            let { xml, fluxosProcesso } = await getXmlFluxo(response.numeroProcesso, response.tipo.codigo)
            if (this.isAmapa()) {
              const fluxoAtualIndex = fluxosProcesso.findIndex(fluxo => fluxo.atual === true)
              fluxosProcesso = fluxosProcesso.slice(0, fluxoAtualIndex + 1)
              parseString(xml, (_, results) => {
                this.setoresFluxo = this.filtrarSetoresFluxo(results.definitions.process[0].callActivity, fluxosProcesso)
              })
            } else {
              parseString(xml, (_, results) => {
                this.setoresFluxo = results.definitions.process[0].callActivity.map(o => ({
                  nome: o['$'].name,
                  acao: o['$'].id
                })).filter(e => !e.acao.includes('INICIAR'))
              })
            }
          }
        } else {
          this.erroBuscaProcesso()
        }
      }
    },
    filtrarSetoresFluxo (callActivities, fluxosProcesso) {
      const status = ['INICIAR', 'ARQUIVAMENTO', 'FINALIZADO', 'ARQUIVADO', 'ARQUIVADOS', 'FINALIZADOS', 'INDEFERIDO']
      return callActivities
        .map(o => ({
          nome: o['$'].name,
          acao: o['$'].id
        }))
        .filter(({ nome, acao }) =>
          !status.some(status => nome.toUpperCase().includes(status)) &&
          acao &&
          !status.some(status => acao.toUpperCase().includes(status)
          ))
        .filter(fluxo => fluxosProcesso.find(ff => ff.idFluxo === fluxo.acao))
    },
    onTextChange (text) {
      this.mensagem = text
    },
    setTextoJustificativa (mensagem) {
      this.$refs.editorTexto.text = mensagem
      this.$refs.editorTexto.emitTextChange()
    },
    async moverProcesso () {
      const mensagem = this.mensagem.replace(/<[\w\s="-:;]+>*|&nbsp;*|<\/\w+>/g, '').replace(/( ){2,}/g, '$1').trim()
      if (mensagem.length > 10 && ((this.processo.status === 'AGUARDANDO_ANALISE_DISTRIBUICAO') || (this.processo.status === 'AGUARDANDO_DISTRIBUICAO'))) {
        this.openModal = true
        return
      }
      if (!this.setor && (this.processo.status !== 'AGUARDANDO_ANALISE_DISTRIBUICAO' && this.processo.status !== 'AGUARDANDO_DISTRIBUICAO')) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Selecione a caixa')
      else if (mensagem.length < 10) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'O campo "Motivo da mudança" deve estar preenchido com no minímo 10 caracteres')
      else {
        const response = await moverProcesso(this.processo.id, this.setor, this.mensagem)
        if (!response) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Erro ao mover processo, verifique sua conexão')
        else {
          this.processo = await buscarProcesso(this.numProcesso)
          if (this.isAmapa()) {
            this.dados.justificativa = this.mensagem
          }

          this.setor = null
          if (this.processo.status.includes('DISTRIBUICAO') ||
          (this.isAmapa() && (this.processo.setor === 'DIPRE' || this.processo.setor === 'DIROT'))) {
            await this.atualizaTarefa()
            this.openModal = true
            return
          }

          if (this.isAmapa()) {
            await this.criarDespachoMovimentarProcesso(this.dados)
            this.dados.justificativa = ''
            this.dados.idProcesso = null
            this.dados.anexos = []
          }
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo movido')
          this.limpar()
        }
      }
    },
    async atualizaTarefa () {
      const taskResponse = await buscarTarefa(this.processo.id)
      if (!taskResponse) {
        return
      }
      this.tarefa = {
        name: taskResponse.nameKeyCurrentTask,
        acoes: taskResponse.nextDecisions.map(d => ({
          nome: d.label || d.codigo,
          valor: d.codigo
        }))
      }
    },

    uploadFile (file) {
      this.dados.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 360,
          codigo: 'ANEXO_MANUTENCAO'
        }
      })
    },

    removeDocumento (item) {
      this.dados.anexos.splice(
        _.findIndex(this.dados.anexos, anexo => anexo === item),
        1
      )
    },

    async limpar () {
      this.processo = null
      this.setor = null
      this.setoresFluxo = null
      this.numProcesso = ''
      this.mensagem = ''
      this.openModal = false
      this.dados.anexos = []
    },
    async  voltar () {
      this.$router.push('/selecionarModulo')
    },
    closeModal () {
      this.openModal = false
    },
    openModalNotificacao () {
      this.showModalNotificacao = true
    },

    fecharModalNotificacao () {
      this.showModalNotificacao = false
    },
    isMaranhao () {
      return process.env.ESTADO === 'ma'
    },
    isAmapa () {
      return process.env.ESTADO === 'ap'
    },
    async getConversaPerdidaPendente (id) {
      let processoId
      if (id) {
        processoId = id
      } else {
        processoId = this.processo.id
      }
      axios({
        method: 'GET',
        url: `conversa/processo/${processoId}/solicitacao/aberta`
      })
        .then((existe) => {
          this.conversaAberta = existe
        })
    }
  }
}
</script>
<style lang="scss" scoped>
    $font-size-small: 12px;

      .color-default {
        color: white;
        font-size: 16px;
      }
      .botao-limpar {
        color: #009d64 !important;
        font-size: 16px;
        border: none;
        background-color: none;
      }
      .caixa-pesquisa {
        margin-bottom: 10px;
      }
      .pesquisa {
        display: flex;
        align-items: center;
        gap: 5px;
      }
      .span-titulo {
        margin-top: 0;
        margin-bottom: 3px;
        font-size: 32px;
        margin-left: 20px;
      }
      .box-processo {
        min-width: 700px;
        padding-left: 3px;
        padding-right: 3px;
      }
      .select {
        margin-right: 20px;
        margin-top: none;
        margin-bottom: 5px;
      }
      .span-style {
        font-weight: normal;
      }
      .botao-voltar {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .center {
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center;
      }
      .box-titulo {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .col-principal {
        width: 100%;
        min-width: 685px;
      }
      .botao-processo {
        width: 100%;
        display: flex;
        justify-content: flex-end;
      }
      .right {
        align-items: right;
      }
      .button-mover {
        margin-top: 15px;
      }
  </style>



// WEBPACK FOOTER //
// src/screens/manutencao/MovimentarProcessos.vue